/**
 * @generated SignedSource<<a93fb0073b64b2697da380516b574bc3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PictureDialogUploadMutation$variables = {
  jpegBase64: string;
};
export type PictureDialogUploadMutation$data = {
  readonly uploadLearnerPicture: {
    readonly learner: {
      readonly id: string;
      readonly picture: {
        readonly preset: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type PictureDialogUploadMutation = {
  response: PictureDialogUploadMutation$data;
  variables: PictureDialogUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jpegBase64"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "jpegBase64",
        "variableName": "jpegBase64"
      }
    ],
    "concreteType": "LearnerPicturePayload",
    "kind": "LinkedField",
    "name": "uploadLearnerPicture",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnerPicture",
            "kind": "LinkedField",
            "name": "picture",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preset",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PictureDialogUploadMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PictureDialogUploadMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "91ffbd82a82e04ed407979b08afa42e4",
    "id": null,
    "metadata": {},
    "name": "PictureDialogUploadMutation",
    "operationKind": "mutation",
    "text": "mutation PictureDialogUploadMutation(\n  $jpegBase64: String!\n) {\n  uploadLearnerPicture(jpegBase64: $jpegBase64) {\n    learner {\n      id\n      picture {\n        preset\n        url\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec1d0b36e51c9637fcfe072adae51153";

export default node;
